import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

const TiposStatusTable = ({ tiposstatus, setIdTipoStatus, setOpenModal }) => {
  const columns = [
    {
      accessorKey: 'descripcion',
      header: 'Tipo',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idtipostatus',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idtipostatus } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdTipoStatus(idtipostatus);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
                   variant="falcon-default"
                   size="sm"
                   title="Eliminar"
                   onClick={() => {
                     setIdMunicipioToDelete(idmunicipio);
                     setOpenConfirm(true);
                   }}
                 >
                   <FontAwesomeIcon icon="trash-alt" />
                 </Button> */}
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={tiposstatus}
        title="Tipos de Status"
        columns={columns}
        addAction={() => {
          setIdTipoStatus(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};

TiposStatusTable.propTypes = {
  tiposstatus: PropTypes.array.isRequired,
  setIdTipoStatus: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};

export default TiposStatusTable;
